import React, { useState } from "react";
import { Image, Card, Button } from "@nextui-org/react"; 
import Logo from "../assets/Logo"; 
import FormInput from "../components/FormInput"; 
import axios from "axios"; 
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {Link} from "react-router-dom"; 
import { useNavigate } from "react-router-dom";
import "./Signup.css";

const apiURL = import.meta.env.VITE_ENVIRONMENT==="development" ? "http://localhost:5000": import.meta.env.VITE_API_URL;
const Signup = () => {
  const [values, setValues] = useState({
    firstname: "",
    lastname: "",
    email: "",
    postalCode: "",
    currency: "", 
    password: "",
    confirmpassword: "",
  });
  const [passwordError, setPasswordError] = useState(""); // To track the password matching error
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleOnChange = (ev) => {
    setValues({ ...values, [ev.target.name]: ev.target.value.trim() });
    // Check if passwords match when user types in confirmpassword
    if (ev.target.name === "confirmpassword") {
      if (ev.target.value !== values.password) {
        setPasswordError("Passwords do not match!");
      } else {
        setPasswordError(""); // Clear error when passwords match
      }
    }
  };

  const inputs = [
    {
      id: 1,
      type: "text",
      label: "First name",
      name: "firstname",
      placeholder: "Enter your first name",
      errorMessage: "First name should be 3-16 characters and shouldn't include any special characters!",
      required: true,
      pattern: "^[A-Za-z0-9]{3,16}$",
    },
    {
      id: 2,
      type: "text",
      label: "Last name",
      name: "lastname",
      placeholder: "Enter your last name",
      errorMessage: "Last name should be 3-16 characters and shouldn't include any special characters!",
      required: true,
      pattern: "^[A-Za-z0-9]{3,16}$",
    },
    {
      id: 3,
      label: "Email",
      type: "email",
      name: "email",
      placeholder: "Enter your email",
      errorMessage: "It should be a valid email address!",
      required: true,
    },
    {
      id: 4,
      label: "Postal Code",
      type: "text",
      name: "postalCode",
      placeholder: "Enter your postal code",
      required: true,
    },
    {
      id: 5,
      type: "password",
      label: "Password",
      name: "password",
      placeholder: "Enter your password",
      errorMessage:
        "Password should be 8-20 characters and include at least 1 letter, 1 number, and 1 special character!",
      required: true,
      pattern: "^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$",
    },
    {
      id: 6,
      type: "password",
      label: "Confirm password",
      name: "confirmpassword",
      placeholder: "Confirm your password",
      errorMessage: passwordError, // Dynamically show the password match error
      required: true,
    },
  ];

  const submitForm = async (ev) => {
    ev.preventDefault();
    const { firstname, lastname, postalCode, email, password } = values;
    setLoading(true);

    if (passwordError) {
      toast.error("Please fix the errors before submitting");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${apiURL}/api/signup`, {
        firstName: firstname,
        lastName: lastname,
        emailAddress: email,
        password: password,
        postalCode: postalCode,
      }, {withCredentials:true});
      localStorage.setItem("verified", "yes");
      navigate("/kyc-verification");
    } catch (error) {
      setLoading(false);
      if (error.response) {
        toast.error(error.response.data);
      } else if (error.request) {
        console.error("Error occurred in the request object:", error.request);
      }
    }
  };

  return (
    <div className="min-h-screen flex justify-center items-center">
      <div className="max-w-md w-full bg-white border border-gray-200 rounded-lg shadow-lg p-8 flex flex-col items-center">
        <div className="flex flex-col gap-8 items-center">
          <Logo size="90" />
          <p className="text-[1.6rem] sm:text-[1.7rem] lg:text-[1.8rem] font-bold">Officialbillboard</p>
        </div>
        <h2 className="text-2xl font-bold text-center mb-6">Sign Up</h2>
        <ToastContainer />
        <form className="space-y-4" onSubmit={submitForm}>
          {inputs.map((input) => (
            <FormInput
              key={input.id}
              {...input}
              value={values[input.name]}
              onChange={handleOnChange}
            />
          ))}
          <Button
            type="submit"
            className="w-full bg-blue-500 text-white hover:bg-blue-600 transition"
            disabled={loading}
          >
            {loading ? "Loading..." : "Sign Up"}
          </Button>
        </form>
        <p className="text-sm text-center text-gray-600 mt-4">
          Already have an account?{" "}
          <Link to="/login" className="text-blue-500">
            Login here
          </Link>
        </p>
      </div>
    </div>
  );
};
export default Signup;

